import { useEventAlerts } from "@/hooks/use-event-alerts";
import { SFEvent } from "@/types/salesforce/event";
import { createContext, ReactNode, useContext } from "react";

interface EventAlertContextType {
    alerts: SFEvent[];
    isLoading: boolean;
    removeAlert: (alertId: string) => void;
    clearAllAlerts: () => void;
    refreshAlerts: () => Promise<void>;
    clearClickedEvents: () => void;
}

const EventAlertContext = createContext<EventAlertContextType | null>(null);

export function EventAlertProvider({ children }: { children: ReactNode }) {
    const eventAlerts = useEventAlerts();

    return <EventAlertContext.Provider value={eventAlerts}>{children}</EventAlertContext.Provider>;
}

export function useEventAlertContext() {
    const context = useContext(EventAlertContext);
    if (!context) {
        throw new Error("useEventAlertContext must be used within an EventAlertProvider");
    }
    return context;
}
